export default __webpack_public_path__ + "static/media/6-07.06b8982d.svg";